module.exports = __webpack_public_path__ + "static/img/edmonton1.ef5a6ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/edmonton1.jpg
// module id = 81
// module chunks = 9